import { Backdrop, CircularProgress } from "@mui/material";

const LoadingIcon = () => {
  return (
    <div>
      <Backdrop sx={{zIndex: 1000}} open>
        <div>
          <CircularProgress />
        </div>
        <div
          style={{
            color: "white",
          }}
        >
          読み込みに時間がかかる場合があります
        </div>
      </Backdrop>
    </div>
  );
};

export default LoadingIcon;
